import React from 'react'

function Currencies() {
  return (
    <div>Currencies</div>
  )
}

export default Currencies